module.exports = __webpack_public_path__ + "static/footer-logo-3526c9eec3241b84ae81e15b9d2531af.png";